import Input from "../../../components/input";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  listUserProjects,
  userAuthenticate,
} from "../../../hooks/local/userReducer";
import { toast } from "react-toastify";
import Button from "../../../components/button";
import { FiMail, FiLock } from "react-icons/fi";

const SignIn = () => {
  document.title = "Sign in - CloudVantage";

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const loading = useSelector((state) => state.user.loading);

  const signInForm = useFormik({
    initialValues: {
      emailAddress: "",
      userPassword: "",
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
        .required("Please provide your email address")
        .email("Please provide your email address"),
      userPassword: Yup.string().required("Password cannot be empty"),
    }),

 onSubmit: async (values, { resetForm }) => {
  try {
    const signInData = {
      email: values.emailAddress,
      password: values.userPassword,
    };

    const payload = await dispatch(userAuthenticate(signInData)).unwrap();

    if (payload?.statuscode === '00') {
      await dispatch(listUserProjects());

      const redirectPath =
        location.state?.actionType === 'saveVpsActionOnAuthClick'
          ? '/client-area/vps'
          : '/client-area';

      navigate(redirectPath);
      resetForm();
    }
  } catch (error) {
    toast.error(
      error?.statusmessage ||
        'Unable to connect to CloudVantage. Please check your internet connection and try again.',
      { theme: 'colored' }
    );
  }
}
  });

  return (
    <div className="w-full">
      <div className="mb-10 text-center md:text-left">
        <h2 className="text-2xl font-bold dark:text-white mb-2">Welcome back</h2>
        <p className="text-gray-400 text-sm">Sign in to your account to continue</p>
      </div>

      <form onSubmit={signInForm.handleSubmit} className="grid gap-5">
        <Input
          label={"Email"}
          type={"email"}
          name={"emailAddress"}
          placeholder="Enter your email address"
          prefixIcon={FiMail}
          value={signInForm.values.emailAddress}
          onChange={signInForm.handleChange}
          onBlur={signInForm.handleBlur}
          onError={
            signInForm.touched.emailAddress && signInForm.errors.emailAddress
              ? signInForm.errors.emailAddress
              : null
          }
        />

        <div className="grid gap-1">
          <Input
            label={"Password"}
            type={"password"}
            isPassword={"true"}
            name={"userPassword"}
            placeholder="············"
            prefixIcon={FiLock}
            value={signInForm.values.userPassword}
            onChange={signInForm.handleChange}
            onBlur={signInForm.handleBlur}
            onError={
              signInForm.touched.userPassword && signInForm.errors.userPassword
                ? signInForm.errors.userPassword
                : null
            }
          />
        </div>

        <div className="flex items-center justify-between text-sm">
          <label className="flex items-center gap-2 cursor-pointer dark:text-gray-300">
            <input type="checkbox" className="rounded border-gray-300 text-primaryBlue focus:ring-primaryBlue" />
            <span>Remember me</span>
          </label>
          <Link
            to={"/password-reset-link"}
            className="text-primaryBlue font-medium hover:underline"
          >
            Reset Password!
          </Link>
        </div>

        <div className="mt-8">
          <Button
            buttonRole={"submit"}
            loading={loading}
            buttonText={"Login"}
            width="w-full"
            bgColor="bg-primaryBlue text-white w-full py-4 text-lg font-semibold rounded-lg shadow-lg shadow-blue-200 dark:shadow-none transition-transform active:scale-[0.98]"
          />
        </div>

        {/* <p className="mt-8 text-center text-sm text-gray-500 dark:text-gray-400">
          Dont Have an account?{" "}
          <Link
            to={"/create-account"}
            className="text-primaryBlue font-semibold hover:underline"
          >
            Create Account
          </Link>
        </p> */}
      </form>
    </div>
  );
};

export default SignIn;
